import _toConsumableArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _wrapNativeSuper from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _classPrivateFieldInitSpec from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/es.weak-map.js";
// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { compactFromU8aLim, compactToU8a, isHex, isU8a, logger, stringify, u8aConcatStrict, u8aToHex, u8aToU8a } from '@polkadot/util';
import { compareSet, decodeU8aVec, sortSet, typeToConstructor } from "../utils/index.js";
var l = logger('BTreeSet');
/** @internal */

function decodeSetFromU8a(registry, ValClass, u8a) {
  var output = new Set();

  var _compactFromU8aLim = compactFromU8aLim(u8a),
      _compactFromU8aLim2 = _slicedToArray(_compactFromU8aLim, 2),
      offset = _compactFromU8aLim2[0],
      count = _compactFromU8aLim2[1];

  var result = new Array(count);

  var _decodeU8aVec = decodeU8aVec(registry, result, u8a, offset, ValClass),
      _decodeU8aVec2 = _slicedToArray(_decodeU8aVec, 1),
      decodedLength = _decodeU8aVec2[0];

  for (var i = 0; i < count; i++) {
    output.add(result[i]);
  }

  return [ValClass, output, decodedLength];
}
/** @internal */


function decodeSetFromSet(registry, ValClass, value) {
  var output = new Set();
  value.forEach(function (val) {
    try {
      output.add(val instanceof ValClass ? val : new ValClass(registry, val));
    } catch (error) {
      l.error('Failed to decode key or value:', error.message);
      throw error;
    }
  });
  return [ValClass, output, 0];
}
/**
 * Decode input to pass into constructor.
 *
 * @param ValClass - Type of the map value
 * @param value - Value to decode, one of:
 * - null
 * - undefined
 * - hex
 * - Uint8Array
 * - Set<any>, where both key and value types are either
 *   constructors or decodeable values for their types.
 * @param jsonSet
 * @internal
 */


function decodeSet(registry, valType, value) {
  var ValClass = typeToConstructor(registry, valType);

  if (!value) {
    return [ValClass, new Set(), 0];
  } else if (isU8a(value) || isHex(value)) {
    return decodeSetFromU8a(registry, ValClass, u8aToU8a(value));
  } else if (Array.isArray(value) || value instanceof Set) {
    return decodeSetFromSet(registry, ValClass, value);
  }

  throw new Error('BTreeSet: cannot decode type');
}

var _ValClass = /*#__PURE__*/new WeakMap();

export var BTreeSet = /*#__PURE__*/function (_Set) {
  _inherits(BTreeSet, _Set);

  var _super = _createSuper(BTreeSet);

  function BTreeSet(registry, valType, rawValue) {
    var _this;

    _classCallCheck(this, BTreeSet);

    var _decodeSet = decodeSet(registry, valType, rawValue),
        _decodeSet2 = _slicedToArray(_decodeSet, 3),
        ValClass = _decodeSet2[0],
        values = _decodeSet2[1],
        decodedLength = _decodeSet2[2];

    _this = _super.call(this, sortSet(values));

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _ValClass, {
      writable: true,
      value: void 0
    });

    _this.registry = registry;
    _this.initialU8aLength = decodedLength;

    _classPrivateFieldSet(_assertThisInitialized(_this), _ValClass, ValClass);

    return _this;
  }

  _createClass(BTreeSet, [{
    key: "encodedLength",
    get:
    /**
     * @description The length of the value when encoded as a Uint8Array
     */
    function get() {
      var len = compactToU8a(this.size).length;

      var _iterator = _createForOfIteratorHelper(this.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var v = _step.value;
          len += v.encodedLength;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return len;
    }
    /**
     * @description Returns a hash of the value
     */

  }, {
    key: "hash",
    get: function get() {
      return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the value is an empty value
     */

  }, {
    key: "isEmpty",
    get: function get() {
      return this.size === 0;
    }
    /**
     * @description The actual set values as a string[]
     */

  }, {
    key: "strings",
    get: function get() {
      return _toConsumableArray(_get(_getPrototypeOf(BTreeSet.prototype), "values", this).call(this)).map(function (v) {
        return v.toString();
      });
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */

  }, {
    key: "eq",
    value: function eq(other) {
      return compareSet(this, other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */

  }, {
    key: "inspect",
    value: function inspect() {
      var inner = new Array();

      var _iterator2 = _createForOfIteratorHelper(this.values()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var v = _step2.value;
          inner.push(v.inspect());
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return {
        inner: inner,
        outer: [compactToU8a(this.size)]
      };
    }
    /**
     * @description Returns a hex string representation of the value. isLe returns a LE (number-only) representation
     */

  }, {
    key: "toHex",
    value: function toHex() {
      return u8aToHex(this.toU8a());
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */

  }, {
    key: "toHuman",
    value: function toHuman(isExtended) {
      var json = [];

      var _iterator3 = _createForOfIteratorHelper(this.values()),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var v = _step3.value;
          json.push(v.toHuman(isExtended));
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return json;
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = [];

      var _iterator4 = _createForOfIteratorHelper(this.values()),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var v = _step4.value;
          json.push(v.toJSON());
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return json;
    }
    /**
     * @description Returns the base runtime type name for this instance
     */

  }, {
    key: "toRawType",
    value: function toRawType() {
      return "BTreeSet<".concat(this.registry.getClassName(_classPrivateFieldGet(this, _ValClass)) || new (_classPrivateFieldGet(this, _ValClass))(this.registry).toRawType(), ">");
    }
    /**
     * @description Returns the string representation of the value
     */

  }, {
    key: "toString",
    value: function toString() {
      return stringify(this.toJSON());
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */

  }, {
    key: "toU8a",
    value: function toU8a(isBare) {
      var encoded = new Array();

      if (!isBare) {
        encoded.push(compactToU8a(this.size));
      }

      var _iterator5 = _createForOfIteratorHelper(this.values()),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var v = _step5.value;
          encoded.push(v.toU8a(isBare));
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return u8aConcatStrict(encoded);
    }
  }], [{
    key: "with",
    value: function _with(valType) {
      return /*#__PURE__*/function (_BTreeSet) {
        _inherits(_class, _BTreeSet);

        var _super2 = _createSuper(_class);

        function _class(registry, value) {
          _classCallCheck(this, _class);

          return _super2.call(this, registry, valType, value);
        }

        return _createClass(_class);
      }(BTreeSet);
    }
  }]);

  return BTreeSet;
}( /*#__PURE__*/_wrapNativeSuper(Set));